const headers = [
  { label: "Timestamp", key: "timestamp" },
  { label: "Date", key: "date" },
  { label: "Date Of Birth", key: "dob" },
  { label: "Athlete's First Name", key: "fname" },
  { label: "Athlete's Last Name", key: "lname" },
  { label: "Athlete's Phone", key: "athletesPhone" },
  { label: "Graduation Year", key: "classYear" },
  { label: "Sport", key: "sport" },
  { label: "Primary Position", key: "primaryPosition" },
  { label: "Secondary Position", key: "secondaryPosition" },
  { label: "Student Athlete 'GMAIL' address ", key: "gmail" },
  { label: "High School Name,  City / State", key: "school" },
  { label: "State Student Athlete resides", key: "resides" },
  { label: "Travel Team Name", key: "travelTeam" },
  { label: "Parent Email #1", key: "parentsEmail1" },
  { label: "Parent Email #2", key: "parentsEmail2" },
  { label: "Parent #1 Phone Number", key: "parentsPhone1" },
  { label: "Parent #2 Phone Number", key: "parentsPhone2" },
  { label: "Parent #1 Name", key: "fatherName" },
  { label: "Parent #2 Name", key: "motherName" },
  { label: "CSA's Advocates Name", key: "advocate" },
  { label: "Comment", key: "comment" },
  { label: "Referrence", key: "ref" },
  { label: "Jersey #", key: "jersey" },
  { label: "Height / Weight", key: "heightWeight" },
  { label: "GPA", key: "gpa" },
  { label: "SAT/ACT Scores", key: "satAct" },
  { label: "Intended Major", key: "major" },
  {
    label:
      "Athletes Strengths - List in Bullet point format with proper spelling, capitalization and grammar.",
    key: "strengths",
  },
  {
    label:
      "Hobbies (List with bullet points, dates, proper capitalization and grammar so we may just cut and paste)",
    key: "hobby",
  },
  {
    label:
      "Extracurricular Groups, Clubs (List with bullet points, dates, proper capitalization and grammar so we may just cut and paste) ​",
    key: "extra",
  },
  {
    label: "High School Coach Name, Email Address, Phone Number",
    key: "highschoolCoach",
  },
  {
    label: "Specialty Training Coach, Name, Email Address, Phone Number",
    key: "specialCoach",
  },
  {
    label:
      "Athletic Awards, Honors (List with bullet points, dates, proper capitalization and grammar so we may just cut and paste)  Example:  Academic All Conference 2018",
    key: "athawards",
  },
  {
    label:
      "Academic Awards, Honors (List with bullet points, dates, proper capitalization and grammar so we may just cut and paste) Example:  Academic All Conference 2018",
    key: "acaawards",
  },
  {
    label:
      "Special Stats (Example:  Right Handed, Left Handed, Speed, other sport specific measurable's) ",
    key: "specialties",
  },
  {
    label:
      "NCAA#  (please register at www.ncaa.org and enter the Eligibility Center, when finished you will receive a long number, input here!)",
    key: "ncaa",
  },
  {
    label:
      "Please Sign and re-attach the Financial Agreement that was included in the email that you've received. If you would like to Electronically sign it,  then go to https://signrequest.com/en/  Please include ALL pages and there are FREE scanning App's and your Notes App can scan too.",
    key: "finAgreement",
  },
  {
    label:
      "Please attach 1 Head Shot and a minimum of 3 Action Photos in their competitive team uniform, you can change them after OnBoarding by sending updated photos to CSAHelpme@gmail.com",
    key: "photos",
  },
];
export default headers;
